import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';
import { IReceiverService } from '../../Infrastructure/CorBase/ServicesFactoryBase';

export class ReceiverService extends BaseService implements IReceiverService {
	constructor() {
		super('/receiver');
	}

	public getRefreshById(id: number) {
		return super.getByIdWithResourceName(id, this._resourceName + '/refresh');
	}

	public getRefreshWithScreenById(id: number) {
		return super.getByIdWithResourceName(id, this._resourceName + '/refreshWithScreen');
	}

	public getAllByFilter(filter: ReceiverFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getAllByRefreshFilter(filter: ReceiverFilter) {
		return super.getAllByFilterBase(filter, 'refresh');
	}

	public getPreviewById(id: number) {
		return super.getByIdWithResourceName(id, `${this._resourceName}/preview`);
	}

	/*přidani obrazovek k taksu*/
	public updateReceiversToTask(id: number, data: any) {
		return super.updateBase(this._resourceName + '/receiver-to-task/' + id, data);
	}

	public updateTenant(id: number, data: any) {
		return super.updateBase(this._resourceName + '/update-tenant/' + id, data);
	}

    
    public updateTenantList(list: number[]) {    
		return this.updateListWithResourceName(list, 'update-tenant-list');
    }

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list');
	}

	public addList(list: number[]) {
		return this.updateListWithResourceName(list, 'add-list');
	}

	public reset(list: number[]) {
		return this.updateListWithResourceName(list, 'reset');
	}

	public softReset(list: number[]) {
		return this.updateListWithResourceName(list, 'soft-reset');
	}
}

export class ReceiverFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted?: boolean | null, idGroup?: number | null, idTask?: number | null, notIdTask?: number | null
		, componentTypeIdentifier?: string | null, onlyComponentsInStateAcceptingTask?: boolean | null
		, idTag?: number | null, notAssigned?: boolean | null, isSuperUser?: boolean | null) {
		super();
		this._idTag = idTag;
		this._idGroup = idGroup;
		this._idGroup = idGroup;
		this._idTenant = idTenant;
		this._idTask = idTask;
		this._notIdTask = notIdTask;
		this._isDeleted = isDeleted;
		this._componentTypeIdentifier = componentTypeIdentifier;
		this._onlyComponentsInStateAcceptingTask = onlyComponentsInStateAcceptingTask;
		this._notAssigned = notAssigned;
		this._isSuperUser = isSuperUser;
	}

	private _idTenant?: number | null;
	private _idTask?: number | null;
	private _notIdTask?: number | null;
	private _isDeleted?: boolean | null;
	private _idGroup?: number | null;
	private _idTag?: number | null;
	private _componentTypeIdentifier?: string | null;
	private _onlyComponentsInStateAcceptingTask?: boolean | null;
	private _notAssigned?: boolean | null;
	private _isSuperUser?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTag != null ? { IdTag: this._idTag } : {}),
			(this._idGroup != null ? { IdGroup: this._idGroup } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idTask != null ? { IdTask: this._idTask } : {}),
			(this._notIdTask != null ? { NotIdTask: this._notIdTask } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {}),
			(this._componentTypeIdentifier != null ? { ComponentTypeIdentifier: this._componentTypeIdentifier } : {}),
			(this._onlyComponentsInStateAcceptingTask != null ? { OnlyComponentsInStateAcceptingTask: this._onlyComponentsInStateAcceptingTask } : {}),
			(this._notAssigned != null ? { NotAssigned: this._notAssigned } : {}),
			(this._isSuperUser != null ? { IsSuperUser: this._isSuperUser } : {}),
		);

		return data;
	};
}